import { Component, Input } from '@angular/core';

import { CustomEventService } from '@shared/services/custom-event.service';

import ActionTypesEnum from '@shared/enums/action-constant.enum';
import { PropertiesService } from "@core/services/properties.service";

@Component({
  selector: 'app-widget-edit',
  templateUrl: './widget-edit.component.html'
})
export class WidgetEditComponent {

  @Input() widgetId: string;

  constructor(private customEventService: CustomEventService,
              public propertiesService: PropertiesService) { }

  editWidget(widgetId: string): void {
    this.customEventService.announceEvent(ActionTypesEnum.EDIT_WIDGET, widgetId);
  }

  removeWidget(widgetId: string): void {
    this.customEventService.announceEvent(ActionTypesEnum.DELETE_WIDGET, widgetId);
  }
}
